var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-2f1f480e]{background:rgba(0,93,101,.4980392157)!important}.point-item-bg[data-v-2f1f480e]{background-image:url(" + escape(require("./images/测点详情bg@1x.png")) + ");background-size:100% 100%}", ""]);

// exports
